import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClientModule, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class FilemakerService {
    public url;

    constructor(private _http: HttpClient){
        this.url=GLOBAL.url
    }

    guardarExpediente(draft): Observable<any>{

        console.log(draft)
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })
        
        return this._http.post(this.url+'save/exp', draft,{headers: headers});           } 
}